import { Icon } from "@mui/material";
import SessionsApi from "Classes/API/Administration/SessionsApi";
import SearchStringOrIntReq from "Classes/Models/Requests/StringIntSearchReq";
import AddmissionButton from "layouts/AccountingSessions/AddmissionButton";
import Swal from "sweetalert2";
import { useContext, useState } from "react";
import { UserContext } from "App";
import { useNavigate } from "react-router-dom";
import { Cached } from "@mui/icons-material";
import AppointmentsApi from "Classes/API/Appointments/AppointmentsApi";

const AccSessionDiv = ({
  AccSession,
  EnableFacilityModal,
  GoToAccSessionDetails,
  DeleteAppointment,
  setMovingSession,
  setIsLoaded,
}) => {
  console.log(AccSession);
  const navigate = useNavigate();
  const user = useContext(UserContext);
  let DivColor = "badge-dark";
  const [AccountingSession, setAccountingSession] = useState(AccSession);

  //accSession.packageRefundableAmount == null then set to 0
  if (AccSession.packageRefundableAmount == null) {
    AccSession.packageRefundableAmount = 0;
  }

  if (AccSession.isAdmitted) {
    DivColor = "badge-success";
  } else if (AccSession.isAbsent) {
    DivColor = "badge-danger";
  } else if (!AccSession.isPaidFor) {
    DivColor = "badge-warning";
  } else if (AccSession.packageRefundableAmount < 0) {
    DivColor = "badge-info";
  }

  const ToggleAbsentButtonClick = async (SessionId) => {
    const req = new SearchStringOrIntReq();
    req.SearchInt = SessionId;

    const res = await SessionsApi.ToggleAccountingSessionIsAbsent(req);

    if (res.status === "Success") {
      Swal.fire("Success", res.message, "success");
      console.log("res.data", res.data);
      setAccountingSession(res.data);
      if (setIsLoaded) {
        setIsLoaded(false);
      }
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  const refreshSessionsRemaining = async () => {
    //show swal loader
    Swal.fire({
      title: "Refreshing Sessions Remaining",
      icon: "info",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    const req = new SearchStringOrIntReq();
    req.SearchInt = AccSession.id;

    const res = await AppointmentsApi.RefreshSessionsRemaining(req);
    if (res.status === "Success") {
      Swal.fire("Success", res.message, "success");
      console.log("res.data", res.data);
      setAccountingSession(res.data);
      if (setIsLoaded) {
        setIsLoaded(false);
      }
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  function routeToCreateEntry(userId, accSessionId, therapistId) {
    navigate("../CreateEntry/" + userId, {
      state: { accSessionId: accSessionId, therapistId: therapistId },
    });
  }

  return (
    <div
      id={"AccSessionDiv" + AccSession.id}
      // className={"badge AppHourSessionDiv " + (AccSession.isAdmitted ? "badge-success" : "badge-secondary")}>
      className={"badge AppHourSessionDiv " + DivColor}
    >
      <div className="AppHourSessionDivDetails">
        <span>
          {AccSession.sessionName} (Id: {AccSession.id}) | {AccSession.patientName} |{" "}
          {AccSession.getSessionFacilities.map((Sessionfacility) => {
            return <span>{Sessionfacility.getFacility.name}</span>;
          })}
        </span>
      </div>
      {AccSession.packageRefundableAmount < 0 && (
        <div className="AppHourSessionDivDetails" style={{ marginTop: "0.5em" }}>
          <span style={{ color: "red", fontSize: "1.2em" }}>
            Patient Needs To Pay Before Addmission
          </span>
        </div>
      )}
      {AccSession.availableRemainingSessions != null &&
        AccSession.availableRemainingSessions == 0 && (
          <div className="AppHourSessionDivDetails" style={{ marginTop: "0.5em" }}>
            <span style={{ color: "red", fontSize: "1.2em" }}>
              ({AccSession.availableRemainingSessions}) Sessions Remaining: InSufficient Package
              Balance
            </span>
          </div>
        )}

      {AccSession.availableRemainingSessions != null &&
        AccSession.availableRemainingSessions <= 2 &&
        AccSession.availableRemainingSessions !== 0 && (
          <div className="AppHourSessionDivDetails" style={{ marginTop: "0.5em" }}>
            <span style={{ color: "yellow", fontSize: "1.2em" }}>
              ({AccSession.availableRemainingSessions}) Sessions Remaining: Low Package Balance
            </span>
          </div>
        )}
      {AccSession.availableRemainingSessions != null &&
        AccSession.availableRemainingSessions > 2 && (
          <div className="AppHourSessionDivDetails" style={{ marginTop: "0.5em" }}>
            <span style={{ color: "green", fontSize: "1.2em" }}>
              ({AccSession.availableRemainingSessions}) Sessions Remaining
            </span>
          </div>
        )}
      {user?.userType != "Therapist" && (
        <div className="AppHourSessionDivButtons" style={{ marginTop: "1em" }}>
          <AddmissionButton AccSession={AccSession} />

          <button
            className="btn btn-sm btn-secondary ml-4 pt-2"
            onClick={() => {
              EnableFacilityModal(true, AccSession);
            }}
          >
            <Icon fontSize="7em">P</Icon>
          </button>
          <button
            className="btn btn-sm btn-primary ml-4 pt-2"
            onClick={() => {
              GoToAccSessionDetails(AccSession);
            }}
          >
            <Icon fontSize="4em">I</Icon>
          </button>
          <button
            className="btn btn-sm btn-warning ml-4 pt-2"
            onClick={() => {
              setMovingSession(AccSession);
            }}
          >
            <Icon fontSize="4em">copy</Icon>
          </button>
          <button
            className="btn btn-sm btn-dark ml-4 pt-2"
            onClick={() => {
              DeleteAppointment(AccSession);
            }}
          >
            <Icon fontSize="4em">delete</Icon>
          </button>
          <button
            className="btn btn-sm btn-success ml-4 pt-2"
            onClick={() => {
              refreshSessionsRemaining();
            }}
          >
            <Cached style={{ width: "20px", height: "20px" }} />
          </button>

          {!AccSession.isAbsent && user.userType !== "SubAdmin" && (
            <button
              className="btn btn-sm btn-info ml-4 pt-2"
              onClick={() => {
                ToggleAbsentButtonClick(AccSession.id);
              }}
            >
              A
            </button>
          )}

          {AccSession.isAbsent && user.userType !== "SubAdmin" && (
            <button
              className="btn btn-sm btn-success ml-4 pt-2"
              onClick={() => {
                ToggleAbsentButtonClick(AccSession.id);
              }}
            >
              Un-A
            </button>
          )}
        </div>
      )}
      {(user?.userType == "Therapist" || user?.userType == "Admin") && (
        <div className="therapistDiv">
          <button
            className="btn btn-sm btn-success"
            onClick={() => {
              routeToCreateEntry(AccSession.patientId, AccSession.id, AccSession.therapistId);
            }}
          >
            Add Entry
          </button>
        </div>
      )}
    </div>
  );
};

export default AccSessionDiv;
